import Heading from '@eversports/react-components/primitives/Heading'
import Table, { TableBody, TableHead, TableRow } from '@eversports/react-components/primitives/Table'
import React from 'react'

import { Localized } from '../../localization/react'
import { ConfirmWithOption } from '../../typings/Product'
import { AssignedProduct } from '../Product'
import ProductTableCell from '../Product/ProductTableCell'

interface Props {
  products: Array<ConfirmWithOption>
}

const AssignedProductsList: React.FC<React.PropsWithChildren<Props>> = ({ products }) => (
  <Table>
    <TableHead>
      <TableRow>
        <ProductTableCell>
          <Heading is="h4" variant="small">
            <Localized id="product" />
          </Heading>
        </ProductTableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {products.map((product) => (
        <AssignedProduct key={product.id} product={product} />
      ))}
    </TableBody>
  </Table>
)

export default React.memo(AssignedProductsList)
